import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiService } from 'src/app/api.service';
import { LogVariableEnvironnementUserService } from './log-variable-environnement-user.service'
import { Model_LogVariableEnvironnementUser, Model_VariableEnvironnementUser, AbsPaginatedGrid } from 'src/app/app.models';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { QueryParams_LogVariableEnvironnementUser } from 'src/app/pages/views/settings/variable-environment/variable-environment.service';

@Injectable()
export class LogVariableEnvironnementUserOnlineService extends LogVariableEnvironnementUserService {
    constructor(
        private _httpClient: HttpClient, 
        private _apiService: ApiService
    ) {
        super();
    }

    doSyncLogVariableEnvironnementUserAction(_log: Model_LogVariableEnvironnementUser) {
        return this._httpClient.post<void>(this._apiService.endPoints.doSyncLogsVariableEnvironnementAction_SynchronisationPeripherique, _log)
        .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur'))).toPromise();
    }

    doBuildGridAction(_queryParams: QueryParams_LogVariableEnvironnementUser) {
        let httpParams = new HttpParams();
        Object.keys(_queryParams).forEach(k => httpParams = httpParams.set(k, _queryParams[k]));
        return this._httpClient.get<AbsPaginatedGrid<any>>(this._apiService.endPoints.doBuildGridAction_LogVariableEnvironnementUser, { params: httpParams })
        .pipe(catchError(error => { console.error(error); return throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur'); })).toPromise();
    }
}